import {useRoute} from '@react-navigation/native';
import {Div, HeaderBack, TimeFromNow, TimeLine} from 'components';
import {Ecolors} from 'constant';
import React, {useState} from 'react';
import OrderBuy from './OrderBuy';
import OrderSell from './OrderSell';
import OrderTransfer from './OrderTransfer';

const switchTitleOrder = (t: 'BUY' | 'SELL' | 'TRANSFER' | 'TRANSFER_BUY') => {
  switch (t) {
    case 'BUY':
      return `createordermodal.datlenhmua`;
    case 'SELL':
      return `createordermodal.datlenhban`;
    case 'TRANSFER':
      return `createordermodal.datlenhchuyendoi`;
    case 'TRANSFER_BUY':
      return `createordermodal.datlenhchuyendoi`;
    default:
      return `createordermodal.datlenhban`;
  }
};

function CreateOrderModal() {
  const route = useRoute<any>();
  const orderType: 'BUY' | 'SELL' | 'TRANSFER' = route.params?.orderType;
  const initData: any = route.params?.initData;
  const [stepTimeLine, setStepTimeLine] = useState<number>(1);
  const [tradingTimeString, setTradingTimeString] = useState<string>('');
  const [closedOrderBookTime, setCloseOrderBookTime] = useState<string>('');

  const swithTypeOrder = (
    type: 'BUY' | 'SELL' | 'TRANSFER' | 'TRANSFER_BUY',
  ) => {
    switch (type) {
      case 'BUY':
        return (
          <OrderBuy
            initData={initData}
            stepTimeLine={stepTimeLine}
            setTradingTimeString={setTradingTimeString}
            setCloseOrderBookTime={setCloseOrderBookTime}
            setStepTimeLine={setStepTimeLine}
          />
        );
      case 'SELL':
        return (
          <OrderSell
            initData={initData}
            stepTimeLine={stepTimeLine}
            setStepTimeLine={setStepTimeLine}
            setTradingTimeString={setTradingTimeString}
            setCloseOrderBookTime={setCloseOrderBookTime}
          />
        );
      case 'TRANSFER':
        return (
          <OrderTransfer
            initData={initData}
            stepTimeLine={stepTimeLine}
            setStepTimeLine={setStepTimeLine}
            setTradingTimeString={setTradingTimeString}
            setCloseOrderBookTime={setCloseOrderBookTime}
          />
        );
      case 'TRANSFER_BUY':
        return (
          <OrderTransfer
            initData={initData}
            stepTimeLine={stepTimeLine}
            setStepTimeLine={setStepTimeLine}
            setTradingTimeString={setTradingTimeString}
            setCloseOrderBookTime={setCloseOrderBookTime}
          />
        );
      default:
        return (
          <OrderBuy
            stepTimeLine={stepTimeLine}
            setStepTimeLine={setStepTimeLine}
            setTradingTimeString={setTradingTimeString}
            setCloseOrderBookTime={setCloseOrderBookTime}
          />
        );
    }
  };

  return (
    <Div height={'100%'} flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={switchTitleOrder(orderType)} />
      <TimeLine index={stepTimeLine} />
      {swithTypeOrder(orderType)}
      <TimeFromNow
        isHidden={true}
        toTime={closedOrderBookTime}
        tradingTimeString={tradingTimeString}
      />
    </Div>
  );
}

export default React.memo(CreateOrderModal);
